import { render, staticRenderFns } from "./SelectLegrDialog.vue?vue&type=template&id=066e04ba&scoped=true"
import script from "./SelectLegrDialog.vue?vue&type=script&lang=js"
export * from "./SelectLegrDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectLegrDialog.vue?vue&type=style&index=0&id=066e04ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e04ba",
  null
  
)

export default component.exports